import { Dispatch, SetStateAction, useState } from "react";
import Select from "react-select";
import { USStates } from "../../SubmitTip/resources";
import { capitalizeFirstLetters } from "../../../utils/stringUtils";
import { FilterCriteria, LocationType } from "../../../types";
import CustomLabel from "../../common/CustomLabel";
import devLogger from "../../../utils/devLogger";
import CustomAccordion from "../../common/CustomAccordion";

const ReportLocationFilter = ({
  filterCriteria,
  setFilterCriteria,
}: {
  filterCriteria: FilterCriteria;
  setFilterCriteria: Dispatch<SetStateAction<FilterCriteria>>;
}) => {
  const handleLocation = (
    key?: LocationType | undefined,
    value?: string,
    type?: "main" | "detailed"
  ) => {
    // if (!value || (!key && type === "detailed")) return;

    if (type === "main") {
      const locationFilterValue = value && value.length > 0 ? value : undefined;
      devLogger.log("🚀 ~ locationFilterValue:", locationFilterValue);
      setFilterCriteria((prev) => ({
        ...prev,
        location: locationFilterValue,
      }));
    }

    if (type === "detailed") {
      devLogger.log("val", value);
      setFilterCriteria((prev) => ({
        ...prev,
        detailedIncidentLocation: {
          ...prev.detailedIncidentLocation,
          [key as LocationType]: value,
        },
      }));
    }
  };

  const [locationDisplayed, setLocationDisplayed] =
    useState<LocationType>("state");

  const locationOptions = {
    state: Object.keys(USStates).map((state) => ({
      value: state,
      label: capitalizeFirstLetters(state),
    })),
    county: [], // Replace with actual county options logic
    city: [], // Replace with actual city options logic
  };

  const renderButton = (locationType: LocationType, label: string) => (
    <div
      className={`rounded-[50px] px-[13px] py-[6px] cursor-pointer ${
        locationDisplayed === locationType
          ? "bg-gray-7 text-white"
          : "bg-gray-2 text-gray-4"
      }`}
      onClick={() => setLocationDisplayed(locationType)}
    >
      {label}
    </div>
  );

  return (
    <CustomAccordion label="Location" defaultOpen={true}>
      <div className="flex flex-col gap-4 items-center">
        <CustomLabel
          labelText="Select location"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            placeholder="Location e.g. School"
            // value={filterCriteria?.location || ""}
            onChange={(e) => handleLocation(undefined, e.target.value, "main")}
            className="font-medium text-sm leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
          />
        </CustomLabel>

        {/* Location Type Selection Buttons */}
        <div className="flex items-center gap-2 font-[600] text-[12px] leading-[14px]">
          {renderButton("state", "State")}
          {renderButton("county", "County")}
          {renderButton("city", "City")}
        </div>

        {/* Location Filter Dropdown */}
        <div className="w-full">
          <Select
            components={{ IndicatorSeparator: () => null }}
            placeholder={`Select ${capitalizeFirstLetters(locationDisplayed)}`}
            className="w-full border-gray-7 text-gray-7 rounded-[50px]"
            options={locationOptions[locationDisplayed]}
            value={
              filterCriteria.detailedIncidentLocation[locationDisplayed]
                ? {
                    value:
                      filterCriteria.detailedIncidentLocation[
                        locationDisplayed
                      ],
                    label: capitalizeFirstLetters(
                      filterCriteria.detailedIncidentLocation[locationDisplayed]
                    ),
                  }
                : null
            }
            styles={{
              control: (provided) => ({
                ...provided,
                borderRadius: "24px",
                padding: "8px 8px",
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "#ddd" : "transparent",
              }),
            }}
            onChange={(selectedOption) =>
              handleLocation(
                locationDisplayed,
                selectedOption?.value,
                "detailed"
              )
            }
          />
        </div>
      </div>
    </CustomAccordion>
  );
};

export default ReportLocationFilter;
